import apiConfig from "@/config/apiConfig";
const rootPath = apiConfig.companyApi;
const integralPath = apiConfig.integralApi;
const webPath = apiConfig.financeApi

//积分制
export const enterpriseOperatingIncome = {
    getDate: rootPath + "/enterpriseOperatingIncome/getDate", // 获取填报时间段(get)
    detailNote: rootPath + "/enterpriseOperatingIncome/detailNote", // 获取填报详情(post)
    detail: rootPath + "/enterpriseOperatingIncome/detail", // 获取填报详情(get)
    getPageList: rootPath + "/enterpriseOperatingIncome/getPageList", // 获取填报列表(get)
    getManageDetail: rootPath + "/enterpriseOperatingIncome/getManageDetail", // 查询审批详情数据(get)
    remove: rootPath + "/enterpriseOperatingIncome/remove/", // 根据id删除-批量删除(delete)
    submitAutoStatus: rootPath + "/enterpriseOperatingIncome/submitAutoStatus", // 审核提交(post)
    seedUpdate: rootPath + "/enterpriseSeedStageScore/update", // 种子期(put)
    newlyUpdate: rootPath + "/enterpriseInitialStageScore/update", // 初创期(put)
    growthUpdate: rootPath + "/enterpriseGrowthStageScore/update", // 成长期(put)
    maturationUpdate: rootPath + "/enterpriseMatureStageScore/update", // 成熟期(put)
};

//积分制平台
export const companyPointsSystem = {
    getCompanyData: integralPath + "/companyPointsSystem/getCompanyData", // 获取企业数据(get)
    getLargeTypeManage: integralPath + "/companyPointsSystem/getLargeTypeManage", // 获取明星企业(get)
    getLargeType: integralPath + "/companyPointsSystem/getLargeType", // 获取明星企业有分数(get)
    getWebType: integralPath + "/companyPointsSystem/getWebType", // 获取明星企业有分数(get)

}

//积分制培育库
export const enterpriseThinkTank = {
    getPageList: webPath + "/enterpriseThinkTank/getPageList", // 获取分页数据(get)

}


